import { useMemo } from 'react';
import { getButtonState } from 'src/components/design-system/Button';
import { InvoiceTrigger } from 'src/services/useInvoiceDetailsApi';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from './InvoiceDetailsContext';

const useInvoiceButtonState = (trigger: typeof InvoiceTrigger[number]) => {
  const triggerPreCheck = useContextSelector(InvoiceContext, (value) => value.invoice.triggerPreCheck);
  const [messages, buttonState] = useMemo(
    () => getButtonState(triggerPreCheck, trigger, InvoiceTrigger as unknown as string[]),
    [trigger, triggerPreCheck]
  );
  return [messages, buttonState] as const;
};

export default useInvoiceButtonState;
